<form #dynamicForm="ngForm" [formGroup]="form" (ngSubmit)="handleSubmit($event)">
    <mat-card appearance="outlined">
        <mat-card-header class="page-header" [ngClass]="{'is-done': active}">
            <mat-card-title>
                <img src="https://www.darkedges.com/images/connectid_logo.jpg" />
            </mat-card-title>
        </mat-card-header>
        <mat-card-content [ngClass]="{'is-done': active}">
            <fram-alert></fram-alert>
            <fieldset>
                <ng-container *ngFor="let field of config.callbacks;" dynamicField [config]="field" [group]="form"
                    [form]="formRef">
                </ng-container>
            </fieldset>
        </mat-card-content>
        <mat-card-actions [ngClass]="{'is-done': active}" align="middle">
            <ng-container dynamicField [config]="loginField" [group]="form" [form]="formRef">
            </ng-container>
            <div *ngIf="register">
                New here? <a routerLink="/register">Create an Account</a>
            </div>
        </mat-card-actions>
    </mat-card>
</form>